<template>
  <div class="trainer-manager">
    <sub-navigation :items="menuItems"/>

    <container>
      <router-view></router-view>
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'
import SubNavigation from '@/components/SubNavigation'
import PageTitle from '@/components/PageTitle'
import VButton from '@/components/Forms/VButton'

export default {
  name: 'TrainerManager',
  data: () => ({
    menuItems: [
      { to: '/admin/trainers', title: 'All Trainers' },
      { to: '/admin/trainers/add', title: 'Add Trainer' }
    ]
  }),
   
  created() {
    if (!this.$isAdminUser()) {
      this.$router.push({ path: '/403' })
    }
  },
  components: {
    Container,
    PageTitle,
    VButton,
    SubNavigation
  }
}
</script>

<style lang="stylus" scoped>
  .container
    margin 20px auto 0
</style>



// WEBPACK FOOTER //
// TrainerManager.vue?5ceb36fc